












































































































































































































































































































































































import Vue from 'vue';
import JSConfetti from 'js-confetti';
import EventBus from '@/eventBus.js';
import i18n from 'vue-i18n';
import { isEmail, isStrongPassword } from 'validator';
import { first, get } from 'lodash';
import { EventTicket, TaxRate } from '@/types/GlobalTypes';
import axios from 'axios';
import CoHeadline from '@/components/Atoms/co-headline/CoHeadline.vue';
import CoModal from '@/components/Organisms/co-modal/CoModal.vue';
import CoCardTicket from '@/components/Molecules/co-card-ticket/CoCardTicket.vue';
import CoButton from '@/components/Atoms/co-button/CoButton.vue';
import CoText from '@/components/Atoms/co-text/CoText.vue';
import CoCheckbox from '@/components/Atoms/co-checkbox/CoCheckbox.vue';
import CoLoadingIndicator from '@/components/Atoms/co-loading-indicator/coLoadingIndicator.vue';
import CoForm from '@/components/Molecules/co-form/CoForm.vue';
import CoCardBillingAddress from '@/components/Organisms/co-card-billing-address/CoCardBillingAddress.vue';
import CoLink from '@/components/Atoms/co-link/CoLink.vue';
import CoCard from '@/components/Molecules/co-card/CoCard.vue';
import CoFormGroup from '@/components/Molecules/co-form-group/CoFormGroup.vue';
import CoInput from '@/components/Molecules/co-input/CoInput.vue';
import CoRoundButton from '@/components/Atoms/co-round-button/CoRoundButton.vue';
Vue.prototype.$isMobile = window && window.innerWidth <= 992;
const jsConfetti = new JSConfetti();

interface GuestTicketCheckoutRequest {
    FirstName: string;
    LastName: string;
    Email: string;
    Password: string;
    Phone?: string;
    Company?: string;
    AdditionalInfo?: string;
    Address: string;
    PostalCode: string;
    City: string;
    Country: string;
    VATNumber?: string;
    EventID: string;
    EventTicketTypeID: string;
    OTP?: string;
}

export default {
    name: 'CoEventTicketCheckoutAsGuest',
    components: {
        CoText,
        CoCardTicket,
        CoModal,
        CoHeadline,
        CoButton,
        CoCheckbox,
        CoCardBillingAddress,
        CoCard,
        CoLink,
        CoFormGroup,
        CoInput,
        CoRoundButton,
    },
    props: {
        eventName: {
            type: String,
            required: false,
            default: '',
        },
        eventLocationAddress: {
            type: String,
            required: false,
            default: '',
        },
        eventID: {
            type: String,
            required: true,
        },
        eventStartDate: {
            type: [String, Number, Date],
            required: false,
            default: null,
        },
        eventEndDate: {
            type: [String, Number, Date],
            required: false,
            default: null,
        },
        eventSlug: {
            type: String,
            required: true,
        },
        tickets: {
            type: Array as () => EventTicket[],
            required: false,
            default: () => [] as EventTicket[],
        },
        taxRates: {
            type: Array as () => Array<any> | null,
            default: () => [],
        },
        currency: {
            type: String,
            required: false,
            default: '',
        },
        ticketPurchaseState: {
            type: String,
            required: false,
            default: 'buy',
            validator(value: string) {
                return ['buy', 'success', ''].includes(value);
            },
        },
    },
    data() {
        return {
            step: 1, // 1 - select tickets, 2 - billing address, 3 - otp, 4 - Checkout view
            loading: false,
            selectedTicket: null as EventTicket | null,
            acceptTermsAndConditions: false,
            ticketSelections: {} as Record<string, { ticket: EventTicket; quantity: number }>,
            activeTermsTicket: null as EventTicket | null,
            maxTotalTickets: 25,

            checkoutdata: {} as GuestTicketCheckoutRequest,

            billingAddress: {
                Phone: '',
                Company: '',
                AdditionalInfo: '',
                Address: '',
                PostalCode: '',
                City: '',
                Country: '',
                VATNumber: '',
            },

            timer: 60, // in seconds
            intervalId: null,
        };
    },
    watch: {
        step(val) {
            if (val === 2) {
                // document.querySelector('#altcha').configure({ auto: 'onload', delay: 300 });
                // document.querySelector('#altcha').addEventListener('statechange', (ev) => {
                //     // state can be: unverified, verifying, verified, error
                //     // console.log('state:', ev.detail.state);
                //     if (get(ev, 'detail.state', '') === 'verified') {
                //         this.captchaVerified = true;
                //         // payload contains base64 encoded data for the server
                //         // console.log('payload:', ev.detail.payload);
                //         this.captchaPayload = ev.detail.payload;
                //     }
                // });
            }
        },
        selectedTicket: {
            handler() {
                // reset accept terms and conditions
                this.acceptTermsAndConditions = false;
            },
            deep: true,
        },
    },
    computed: {
        // Read space terms once from the store to avoid per-checkout fetches.
        spaceTermsAndConditions() {
            return this.$store.state.termsAndConditions?.Content || '';
        },
        countdown() {
            const minutes = String(Math.floor(this.timer / 60)).padStart(2, '0');
            const seconds = String(this.timer % 60).padStart(2, '0');
            return `${minutes}:${seconds}`;
        },
        selectedTickets() {
            // eslint-disable-next-line prettier/prettier
            return Object.values(this.ticketSelections).filter(
                (item: { ticket: EventTicket; quantity: number }) => item.quantity > 0
            );
        },
        totalSelectedQuantity() {
            return this.selectedTickets.reduce((total, item) => total + (Number(item.quantity) || 0), 0);
        },
        hasSelectedTickets() {
            return this.selectedTickets.length > 0;
        },
        primaryTicket() {
            if (this.selectedTicket) {
                return this.selectedTicket;
            }
            if (this.selectedTickets.length > 0) {
                return this.selectedTickets[0].ticket;
            }
            return null;
        },
        ticketsWithTerms() {
            return this.selectedTickets.filter((item) => item.ticket.TermsAndConditions?.trim());
        },
        termsListItems() {
            const items = [];
            if (this.spaceTermsAndConditions?.trim()) {
                items.push({ key: 'space-terms', label: this.$t('labels.termsandconditions'), ticket: null });
            }
            this.ticketsWithTerms.forEach((item) => {
                items.push({ key: item.ticket.ID, label: item.ticket.Name, ticket: item.ticket });
            });
            return items;
        },
        ticketsWithCancellation() {
            return this.selectedTickets.filter((item) => item.ticket.CancellationNotice);
        },
        cancellationNoticeDays() {
            if (!this.ticketsWithCancellation.length) {
                return null;
            }
            const noticeDays = this.ticketsWithCancellation
                .map((item) => Number(item.ticket.CancellationNotice) || 0)
                .filter((value) => value > 0);
            if (!noticeDays.length) {
                return this.primaryTicket?.CancellationNotice || null;
            }
            return Math.max(...noticeDays);
        },
        canIClickNext() {
            if (!this.hasSelectedTickets || !this.acceptTermsAndConditions) {
                return false;
            }

            return true;
        },
        canICheckout() {
            if (!this.hasSelectedTickets || !this.acceptTermsAndConditions) {
                return false;
            }

            if (
                !this.checkoutdata.FirstName ||
                !this.checkoutdata.FirstName.trim() ||
                !this.checkoutdata.LastName ||
                !this.checkoutdata.LastName.trim() ||
                !this.checkoutdata.Email ||
                !this.checkoutdata.Email.trim()
            ) {
                return false;
            }
            return true;
        },

        orderTotals() {
            let subtotalInCents = 0;
            let totalInCents = 0;
            const taxMap = new Map<
                string,
                { id: string; name: string; percentage: number; inclusive: boolean; amountInCents: number }
            >();

            const taxRates = this.taxRates || [];

            this.selectedTickets.forEach((item) => {
                const priceInCents = item.ticket.PriceInCents ? item.ticket.PriceInCents : 0;
                const quantity = item.quantity ? item.quantity : 0;
                const lineGross = priceInCents * quantity;
                const taxRate = taxRates.find((rate) => rate.ID === item.ticket.TaxRateID);
                const percentage = taxRate?.Percentage ? taxRate.Percentage : 0;

                if (taxRate && percentage > 0) {
                    if (taxRate.Inclusive) {
                        const lineNet = Math.round(lineGross / (1 + percentage / 100));
                        const lineTax = lineGross - lineNet;
                        subtotalInCents += lineNet;
                        totalInCents += lineGross;

                        const taxKey = `${taxRate.ID || taxRate.Name || percentage}-inclusive`;
                        const existing = taxMap.get(taxKey);
                        if (existing) {
                            existing.amountInCents += lineTax;
                        } else {
                            taxMap.set(taxKey, {
                                id: taxKey,
                                name: taxRate.Name || this.$t('labels.vat'),
                                percentage,
                                inclusive: true,
                                amountInCents: lineTax,
                            });
                        }
                    } else {
                        const lineNet = lineGross;
                        const lineTax = Math.round(lineNet * (percentage / 100));
                        subtotalInCents += lineNet;
                        totalInCents += lineNet + lineTax;

                        const taxKey = `${taxRate.ID || taxRate.Name || percentage}-exclusive`;
                        const existing = taxMap.get(taxKey);
                        if (existing) {
                            existing.amountInCents += lineTax;
                        } else {
                            taxMap.set(taxKey, {
                                id: taxKey,
                                name: taxRate.Name || this.$t('labels.vat'),
                                percentage,
                                inclusive: false,
                                amountInCents: lineTax,
                            });
                        }
                    }
                } else {
                    subtotalInCents += lineGross;
                    totalInCents += lineGross;
                }
            });

            return {
                subtotalInCents,
                totalInCents,
                taxLines: Array.from(taxMap.values()),
            };
        },
        formattedSubtotal() {
            return this.formatPriceFromCents(this.orderTotals.subtotalInCents);
        },
        formattedTotal() {
            return this.formatPriceFromCents(this.orderTotals.totalInCents);
        },
        taxLines() {
            return this.orderTotals.taxLines.map((line) => {
                const label = `${line.name} (${line.percentage}%)`;
                return {
                    id: line.id,
                    label,
                    amount: this.formatPriceFromCents(line.amountInCents),
                };
            });
        },

        currencyChar() {
            if (!this.currency) {
                return '€';
            }

            const currency = this.currency.toUpperCase();

            if (currency === 'EUR') {
                return '€';
            }
            if (currency === 'USD') {
                return '$';
            }

            return currency;
        },
        listTickets() {
            // Filter out deleted tickets and sort by price in ascending corder also filter sold out tickets as last
            return this.tickets
                .filter((ticket) => !ticket.Deleted)
                .sort((a, b) => a.PriceInCents - b.PriceInCents)
                .sort((a, b) => (a.SoldOut ? 1 : 0) - (b.SoldOut ? 1 : 0));
        },
        termsAndConditionsContent() {
            if (this.activeTermsTicket && this.activeTermsTicket.TermsAndConditions) {
                return this.activeTermsTicket.TermsAndConditions;
            }
            return this.spaceTermsAndConditions;
        },
    },
    methods: {
        formatPriceFromCents(cents: number) {
            const priceInCents = cents ? cents : 0;
            let priceStr = (priceInCents / 100).toFixed(2);
            priceStr = priceStr.replace('.', ',');
            return `${priceStr} ${this.currencyChar}`;
        },
        startCountdown() {
            this.timer = 60;
            if (this.intervalId) clearInterval(this.intervalId);
            this.intervalId = setInterval(() => {
                if (this.timer > 0) {
                    this.timer--;
                } else {
                    clearInterval(this.intervalId);
                }
            }, 1000);
        },
        saveBillingAddressData(val) {
            this.checkoutdata.Company = val.Company;
            this.checkoutdata.Address = val.Address;
            this.checkoutdata.AdditionalInfo = val.AdditionalInfo;
            this.checkoutdata.City = val.City;
            this.checkoutdata.PostalCode = val.PostalCode;
            this.checkoutdata.Country = val.Country;
            this.checkoutdata.VATNumber = val.VatNumber;
            this.checkoutdata.Phone = val.Phone;

            this.billingAddress = {
                Phone: this.checkoutdata.Phone,
                Company: this.checkoutdata.Company,
                AdditionalInfo: this.checkoutdata.AdditionalInfo,
                Address: this.checkoutdata.Address,
                PostalCode: this.checkoutdata.PostalCode,
                City: this.checkoutdata.City,
                Country: this.checkoutdata.Country,
                VATNumber: this.checkoutdata.VATNumber,
            };
        },
        validateEmail(value) {
            if (!value) {
                return false;
            }
            return isEmail(value);
        },

        validatePassword(value) {
            if (!value) {
                return false;
            }
        },
        updateTicketQuantity(payload) {
            if (!payload || !payload.id) {
                return;
            }

            const quantity = Number(payload.quantity) || 0;
            const currentQuantity = this.ticketSelections[payload.id]?.quantity || 0;
            const totalExcludingCurrent = this.totalSelectedQuantity - currentQuantity;
            const allowedQuantity = Math.max(this.maxTotalTickets - totalExcludingCurrent, 0);
            const nextQuantity = Math.min(quantity, allowedQuantity);

            if (quantity > allowedQuantity) {
                this.handleMaxTotalReached();
            }

            if (nextQuantity > 0) {
                this.$set(this.ticketSelections, payload.id, {
                    ticket: payload.ticket,
                    quantity: nextQuantity,
                });
                if (!this.selectedTicket) {
                    this.selectedTicket = payload.ticket;
                }
            } else {
                this.$delete(this.ticketSelections, payload.id);
                if (this.selectedTicket && this.selectedTicket.ID === payload.id) {
                    this.selectedTicket = null;
                }
            }
        },
        getSelectedTicketQuantity(ticketId: string) {
            if (!ticketId) {
                return 0;
            }
            return this.ticketSelections[ticketId]?.quantity || 0;
        },
        handleMaxTotalReached() {
            EventBus.$emit('ERROR', {
                Message: this.$t('messages.maxTicketsReached', { max: this.maxTotalTickets }),
            });
        },
        next() {
            this.step = 2;
        },
        showEventDetails() {
            // replace url
            this.$router.replace(`/event/${this.eventSlug}`);

            // hide modal
            this.$refs['co-event-ticket-checkout'].hide();
        },
        hideModal() {
            this.$refs['co-event-ticket-checkout'].hide();
            this.selectedTicket = null;
            this.acceptTermsAndConditions = false;
            this.ticketSelections = {};
            this.activeTermsTicket = null;
            this.step = 1;
        },
        openModal() {
            this.$refs['co-event-ticket-checkout'].show();
        },
        selectTicket(ticket: EventTicket) {
            if (this.loading) {
                return;
            }
            if (!ticket.PriceInCents) {
                ticket.PriceInCents = 0;
            }

            this.selectedTicket = ticket;
        },
        openTermsList() {
            if (!this.termsListItems.length) {
                return;
            }
            this.$refs['terms-and-conditions-list'].show();
        },
        openTermsDetail(ticket: EventTicket | null) {
            this.activeTermsTicket = ticket;
            this.$refs['terms-and-conditions-detail'].show();
        },
        initCheckoutProcess() {
            this.loading = true;
            const tickets = this.selectedTickets
                .map((item) => ({
                    TicketTypeID: item.ticket.ID,
                    Quantity: item.quantity,
                }))
                .filter((ticket) => ticket.TicketTypeID);

            const req = {
                tickets,
                event_id: this.eventID,
                firstName: this.checkoutdata.FirstName,
                lastName: this.checkoutdata.LastName,
                email: this.checkoutdata.Email,
                password: this.checkoutdata.Password,
                phone: this.checkoutdata.Phone,
                company: this.checkoutdata.Company,
                additionalInfo: this.checkoutdata.AdditionalInfo,
                address: this.checkoutdata.Address,
                postalCode: this.checkoutdata.PostalCode,
                city: this.checkoutdata.City,
                country: this.checkoutdata.Country,
                vatNumber: this.checkoutdata.VATNumber,
            };

            axios({
                method: 'POST',
                url: '/public/event/ticket/init',
                data: req,
            })
                .then((response) => {
                    // get token
                    this.loading = false;
                    this.step = 3;
                    this.startCountdown();
                })
                .catch((error) => {
                    this.loading = false;
                    console.error(error);
                    EventBus.$emit('ERROR', { Message: this.$t('errors.failedGeneric') });
                })
                .finally(() => {});
        },
        createOrder() {
            this.loading = true;

            const primaryTicketId = this.primaryTicket?.ID;
            const successURL = `${window.location.origin}/event/${this.eventSlug}?tp=success${
                primaryTicketId ? `&ticket_type_id=${primaryTicketId}` : ''
            }`;
            const cancelURL = `${window.location.origin}/event/${this.eventSlug}?tp=cancel${
                primaryTicketId ? `&ticket_type_id=${primaryTicketId}` : ''
            }`;

            const tickets = this.selectedTickets
                .map((item) => ({
                    TicketTypeID: item.ticket.ID,
                    Quantity: item.quantity,
                }))
                .filter((ticket) => ticket.TicketTypeID);

            const req = {
                tickets,
                event_id: this.eventID,
                success_url: successURL,
                cancel_url: cancelURL,
                firstName: this.checkoutdata.FirstName,
                lastName: this.checkoutdata.LastName,
                email: this.checkoutdata.Email,
                password: this.checkoutdata.Password,
                phone: this.checkoutdata.Phone,
                company: this.checkoutdata.Company,
                additionalInfo: this.checkoutdata.AdditionalInfo,
                address: this.checkoutdata.Address,
                postalCode: this.checkoutdata.PostalCode,
                city: this.checkoutdata.City,
                country: this.checkoutdata.Country,
                vatNumber: this.checkoutdata.VATNumber,
                otp: this.checkoutdata.OTP,
            };

            axios({
                method: 'POST',
                url: '/public/event/ticket',
                data: req,
            })
                .then(async (response) => {
                    const paymentURL = get(response, 'data.ticket.PaymentURL', '');
                    if (paymentURL) {
                        window.location.href = paymentURL;
                    } else {
                        window.location.href = successURL;
                        console.error('No payment URL found');
                    }
                })
                .catch((error) => {
                    this.loading = false;
                    console.error(error);
                    EventBus.$emit('ERROR', { Message: this.$t('errors.failedGeneric') });
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
};
